<template>
    <div class="w-100">
        <div class="grid-wrapper">
            <div class="col-md-12 py-1" v-if="showAssignedToMeSettings">
                <i class="fas fa-cogs pointer fa-2x text-success float-right"
                   @click.stop="changeGridSettings('assignedToMeGrid')"
                   data-toggle="tooltip"
                   :title="$t('buttons.settings.tooltipText')"></i>
                <GridUserSettings ref="assignedToMeSettings"
                                  :visible="showAssignedToMeSettingsForm"
                                  :grid="$refs['assignedToMeGrid']"
                                  :componentName="'profile_assignedToMeGrid'"></GridUserSettings>
                <div style="clear: both;"></div>
            </div>

            <kendo-datasource ref="datasource2"
                              :transport="transportSettings"
                              :schema-model-id="'id'"
                              :schema-total="'total'"
                              :schema-data="'data'"
                              :page-size="defaultGridRows"
                              :server-paging="true"
                              :server-sorting="true"
                              :server-filtering="true"
                              :change="onChange"></kendo-datasource>
            <kendo-grid ref="assignedToMeGrid"
                        :data-source-ref="'datasource2'"
                        :editable="gridOptions.editable"
                        :filterable="gridOptions.filterable"
                        :pageable="gridOptions.pageable"
                        :reorderable="gridOptions.reorderable"
                        :resizable="gridOptions.resizable"
                        :groupable="gridOptions.groupable"
                        :allow-copy="gridOptions.allowCopy"
                        :column-menu="gridOptions.columnMenu"
                        :sortable-mode="gridOptions.sortable.mode"
                        :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                        :sortable-show-indexes="gridOptions.sortable.showIndexes"
                        :selectable="gridOptions.selectable"
                        :scrollable="gridOptions.scrollable"
                        :data-bound="onDatabound"
                        name="assignedToMeGrid">
                <!-- <kendo-grid-column :field="'id'" :filterable="false" :title="$t('registers.forms.gridHeaders.id')" :width="100" :lockable="true" :locked="false"></kendo-grid-column> -->
                <kendo-grid-column :field="'id'" :title="'Id'" :width="100" :lockable="true" :locked="false"></kendo-grid-column>
                <kendo-grid-column :field="'title'" :title="$t('tasks.title')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                <!-- <kendo-grid-column :field="'createdOn'" :title="$t('tasks.assignedOn')" :width="200" :lockable="true" :locked="false" :format="'{0:dd.MM.yyyy}'"></kendo-grid-column>-->
                <kendo-grid-column :field="'assigner'" :title="$t('tasks.assigner')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                <kendo-grid-column :field="'deadline'" :title="$t('tasks.deadline')" :width="200" :lockable="true" :locked="false" :format="'{0:dd.MM.yyyy}'"></kendo-grid-column>
                <!-- <kendo-grid-column :field="'type'" :title="$t('tasks.type')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>-->
                <kendo-grid-column :field="'priority'" :title="$t('tasks.priority')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                <kendo-grid-column :field="'category'" :title="$t('tasks.category')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                <kendo-grid-column :field="'status'" :title="$t('tasks.status')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                <kendo-grid-column field="btnsColumn" :title="' '" :template="assignToMeBtnsTemplate" :width="80" :hidden="!editable"></kendo-grid-column>
            </kendo-grid>
        </div>
        <UpdateModal v-model="updateModel" :show="showUpdate" @onClose="onUpdateClose" @updated="onUpdate"></UpdateModal>
        <DisplayModal :value="displayModel" :show="showDisplay" @onClose="onDisplayClose"></DisplayModal>
        <CompleteModal :value="completeId" :show="showComplete" @onClose="onCompleteClose" @updated="refresh"></CompleteModal>
        <DeclineModal :show.sync="showDecline" :taskId="activeTaskId" @onClose="onModalClose" @updated="refresh"></DeclineModal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import UpdateModal from '@/components/tasks/update.modal';
    import DisplayModal from '@/components/tasks/display.modal';
    import CompleteModal from '@/components/tasks/complete.modal';
    import DeclineModal from '@/components/tasks/decline.modal';
    import BtnsTemplate from '@/components/grid/StandardBtnsTemplate';
    import taskService from '@/services/tasks.service';
    import { mapGetters } from 'vuex';
    import GridUserSettings from '@/components/grid/GridSettingsWrapper';

    export default {
        props: {
            editable: {
                type: Boolean,
                default: false
            },
            userId: {
                type: String,
                default: null
            }
        },
        components: {
            UpdateModal,
            DisplayModal,
            CompleteModal,
            DeclineModal,
            GridUserSettings
        },
        data() {
            return {
                cteatedByMe: [],
                assignedToMe: [],
                transportSettings: {
                    read: {
                        url:
                            this.$store.getters.baseUrl +
                            '/api/tasks/AssignTo/' +
                            (this.userId || ''),
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                editModel: null,
                showEdit: false,
                showDisplay: false,
                displayModel: null,
                showUpdate: false,
                updateModel: null,
                showComplete: false,
                completeId: null,
                showDecline: false,
                showReturn: false,
                activeTaskId: null,
                showAssignedToMeSettings: false,
                showAssignedToMeSettingsForm: false,
                defaultGridRows: this.$store.getters.defaultGridRows,
            };
        },
        methods: {
            onDatabound(e) {
                if (e.sender.options.dataSourceRef === 'datasource2' && !this.showAssignedToMeSettings) {
                    this.showAssignedToMeSettings = true;
                }

                var items = e.sender.items();
                items.each(function (idx, item) {
                    let dataItem = e.sender.dataItem(item);
                    if (dataItem.statusId === 2) {
                        $(item).addClass('left-border-green');
                    } else if (dataItem.statusId === 4 || dataItem.statusId === 7) {
                        $(item).addClass('left-border-blue');
                    }
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) };
                } else {
                    return kendo.stringify(options);
                }
            },
            onChange(data) {
                // parse date field in the grid data
                data.items.forEach(item => {
                    item.deadline = new Date(item.deadline);
                    item.createdOn = new Date(item.createdOn);
                });
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            assignToMeBtnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        // parentComponent: this.$refs.createdByMeGrid,
                        btns: this.editable
                            ? [
                                {
                                    name: 'details',
                                    text: '',
                                    tooltip: this.$t(
                                        'buttons.details.tooltipText'
                                    ),
                                    class: 'btn btn-info',
                                    icon: 'fas fa-eye',
                                    show: true,
                                    clickHandler: this.showDetailsModal
                                },
                                {
                                    name: 'start',
                                    text: '',
                                    tooltip: this.$t('tasks.startTask'),
                                    class: 'btn btn-success',
                                    icon: 'fas fa-edit',
                                    show: e.statusId === 2,
                                    clickHandler: this.onStartTask
                                },
                                {
                                    name: 'decline',
                                    text: '',
                                    tooltip: this.$t('tasks.decline'),
                                    class: 'btn btn-success',
                                    icon: 'fas fa-times-circle',
                                    show: e.statusId === 2,
                                    clickHandler: this.showDeclineModal
                                },
                                {
                                    name: 'complete',
                                    text: '',
                                    tooltip: this.$t('tasks.completeTask'),
                                    class: 'btn btn-success',
                                    icon: 'fas fa-check',
                                    show: e.statusId === 3,
                                    clickHandler: this.onCompleteTask
                                }
                            ]
                            : null
                    }
                };
            },
            showDetailsModal(e) {
                this.displayModel = { ...e };
                this.showDisplay = true;
            },
            showEditModal(e) {
                this.editModel = { ...e };
                this.showEdit = true;
            },
            showUpdateModal(e) {
                this.updateModel = { ...e };
                this.showUpdate = true;
            },
            showDeclineModal(e) {
                this.activeTaskId = e.id;
                this.showDecline = true;
            },
            showReturnModal(e) {
                this.activeTaskId = e.id;
                this.showReturn = true;
            },
            onEditClose() {
                this.showEdit = false;
                this.editModel = null;
            },
            onUpdateClose() {
                this.showUpdate = false;
                this.updateModel = null;
            },
            onDisplayClose() {
                this.showDisplay = false;
                this.displayModel = null;
            },
            onCompleteClose() {
                this.completeId = null;
                this.showComplete = false;
                this.refresh();
            },
            onUpdate(item) {
                this.refresh();
            },
            onEdit(item) {
                this.refresh();
            },
            onCreate(item) {
                this.refresh();
            },
            onStartTask(e) {
                this.startId = e.id;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'success',
                    title: this.$t('tasks.taskStart'),
                    text: this.$t('tasks.taskStartMessage'),
                    accept: this.startTask,
                    acceptText: this.$t('buttons.ok'),
                    cancelText: this.$t('buttons.cancel'),
                    cancel: () => (this.startId = null)
                });
            },
            onCompleteTask(e) {
                this.completeId = e.id;
                this.showComplete = true;
            },

            onModalClose() {
                this.activeTaskId = null;
            },
            startTask() {
                taskService
                    .start(this.startId)
                    .then(() => {
                        this.$vs.notify({
                            color: 'success',
                            title: this.$t('updateSuccess'),
                            text: ''
                        });
                        this.refresh();
                    })
                    .catch(err =>
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        })
                    )
                    .then(() => (this.startId = null));
            },
            refresh(gridName) {
                if (gridName) {
                    this.$refs[gridName].kendoWidget().dataSource.read();
                } else {
                    this.$refs['assignedToMeGrid'].kendoWidget().dataSource.read();
                }
            },
            changeGridSettings(gridName) {
                if (gridName === 'assignedToMeGrid') {
                    this.showAssignedToMeSettingsForm = !this.showAssignedToMeSettingsForm;
                }
            },
        },
        computed: {
            ...mapGetters(['gridOptions']),
            token: function () {
                return this.$store.getters.authToken;
            }
        },
        mounted() { }
    };
</script>

<style lang="scss">
    .grid-wrapper {
        overflow-x: auto;
    }

    .vs-dialog footer {
        padding: 5px;
        .vs-button-filled

    {
        padding: 5px;
        margin-right: 10px;
    }

    }

    tr.left-border-danger {
        &:hover

    {
        color: rgba(255, 0, 0, 0.7) !important;
    }

    td:first-child {
        border-left: 3px solid rgba(255, 0, 0, 0.5) !important;
    }

    }

    tr.left-border-blue {
        &:hover

    {
        color: #3498db !important;
    }

    td:first-child {
        border-left: 3px solid #3498db !important;
    }

    }

    tr.left-border-green {
        &:hover

    {
        color: #4caf50 !important;
    }

    td:first-child {
        border-left: 3px solid #4caf50 !important;
    }
    }
</style>
